import { db } from "@/utils/firebase";
import {
  doc,
  updateDoc,
  getDoc,
  setDoc,
  deleteDoc,
  serverTimestamp,
} from "firebase/firestore";

const handleRequest = async (collection, requestId, status) => {
  try {
    // Reference to the specific user document
    const docRef = doc(db, collection, requestId);

    // Update the user document with the provided data
    await updateDoc(docRef, {
      status,
      updated_at: serverTimestamp(),
    });

    console.log("User data updated successfully.");
  } catch (error) {
    console.error("Error updating user data:", error.message);
    throw new Error("Failed to update user data. Please try again later.");
  }
};

const archiveRequest = async (collection, requestId) => {
  try {
    // Reference to the specific document
    const docRef = doc(db, collection, requestId);
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) {
      throw new Error("Document does not exist.");
    }

    // Get the document data
    const docData = docSnap.data();

    // Add the document to the "archived" collection
    const archivedCollection = `archived_${collection}`;
    const archivedDocRef = doc(db, archivedCollection, requestId);

    await setDoc(archivedDocRef, {
      ...docData,
      archived_at: serverTimestamp(), // Add a timestamp for archiving
    });

    // Delete the document from the original collection
    await deleteDoc(docRef);

    console.log(
      "Document successfully archived and removed from the original collection."
    );
  } catch (error) {
    console.error("Error archiving document:", error.message);
    throw new Error("Failed to archive the document. Please try again later.");
  }
};

export { handleRequest, archiveRequest };
